import React from 'react';
import { LogoReversed } from './Logo';
export function Footer() {
  return <footer className="bg-background-primary-filled text-neutral-white py-12" data-id="element-63">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-64">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-65">
          <div className="flex flex-col items-center md:items-start gap-4" data-id="element-66">
            <LogoReversed width={120} height={40} data-id="element-67" />
            <p className="text-sm text-neutral-white/80 text-center md:text-left max-w-sm mt-2" data-id="element-68">
              Jerry Gibb – Coastline Mortgages
              <br data-id="element-69" />
              3 Alicante Mews, Secret Harbour, WA, 6173
              <br data-id="element-70" />
              <a href="tel:0408247276" className="hover:underline" data-id="element-71">
                0408 247 276
              </a>
            </p>
          </div>

          <div className="text-sm text-neutral-white/80 text-center md:text-right" data-id="element-72">
            <p data-id="element-73">© {new Date().getFullYear()} Jerry Gibb Mortgage Broker.</p>
            <p data-id="element-74">All rights reserved.</p>
          </div>
        </div>
      </div>
    </footer>;
}